import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import Field from "../../../../../components/Field";
import Select from "../../../../../components/Inputs/Select";
import { manageAbilityOptions } from "../constants";

function ManageAbilitySelect({ form, disabled }) {
    const { t } = useTranslation();

    const onManageAbilityChange = useCallback(() => {
        form.setFieldsValue({
            roles: [],
        });
    }, [form]);

    return (
        <Field
            name="manageAbility"
            label={t("manage-ability")}
            rules={[
                {
                    required: true,
                    message: t("required-manage-ability"),
                },
            ]}
        >
            <Select
                placeholder={t("manage-ability")}
                onChange={onManageAbilityChange}
                disabled={disabled}
            >
                {manageAbilityOptions.map(({ value, label }) => (
                    <Select.Option key={value} value={value}>
                        {t(label)}
                    </Select.Option>
                ))}
            </Select>
        </Field>
    );
}

export default ManageAbilitySelect;
